import { get, patch, post } from "../../utils/api";

export const shopperList = (data) => {
    return get(`/admin/user?search=${data?.search || ""}&page=${data.page || 1}&limit=${data.limit || 10}`);
};

export const personalShopperList = (data) => {
    const statusQuery =
        data?.status && data.status !== "all"
            ? `&status=${encodeURIComponent(data.status)}`
            : "";
    return get(
        `/admin/personal-shopper/list?search=${data?.search || ""}&page=${data.page || 1}&limit=${data.limit || 10}${statusQuery}`
    );
};

export const personalShopperById = (shopperId) => {
    const seg = shopperId == null ? "" : String(shopperId).trim();
    if (!seg || seg === "undefined" || seg === "null") {
        return Promise.reject({ data: { message: "Shopper id is missing" } });
    }
    return get(`/admin/personal-shopper/${encodeURIComponent(seg)}`, {});
};

export const shopperStatusChange = ({ id, is_suspended }) => {
    return patch(`/admin/personal-shopper/${id}/suspended-user`, { is_suspended });
};

export const shopperCreate = (data) => {
    return post("/admin/user", data);
};

export const shopperRoleList = () => {
    return get("/admin/user-role");
};

export const shopperApi = {
    shopperList,
    personalShopperList,
    personalShopperById,
    shopperStatusChange,
    shopperCreate,
    shopperRoleList,
};
